
function About() {
  return (
    <h1>About Stocks and Stuff</h1>
  )
}

export default About